/* ========================================================================
   Job Alert form
 ========================================================================== */

app.jobAlertForm = (function () {
  'use strict';

  function init() {
    const forms = document.querySelectorAll('[data-jobalert-form]');
    if (!forms) return;

    // init client-side validation
    app.formValidation.validationService.bootstrap();

    forms.forEach((form) => {
      const educationSelect = form.querySelector('[name="jobalert_education"]');
      const competenceSelect = form.querySelector(
        '[name="jobalert_competence"]'
      );
      const disciplineSelect = form.querySelector(
        '[name="jobalert_discipline"]'
      );
      const schoolSelect = form.querySelector('[name="jobalert_school"]');
      const firstNameField = form.querySelector('[name="jobalert_firstname"]');
      const emailField = form.querySelector('[name="jobalert_email"]');
      const csrfField = form.querySelector(
        '[name="__RequestVerificationToken"]'
      );

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        var overlay = LoadingOverlay(form);

        var data = {
          education: educationSelect.value,
          competence: competenceSelect.value,
          discipline: disciplineSelect.value,
          school: schoolSelect.value,
          firstName: firstNameField.value,
          emailAddress: emailField.value,
        };

        fetch('/api/jobalert/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfField.value,
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success === true) {
              Toast(data.message, 'success', 10000);
              form.reset();
            } else if (data.success === false) {
              Toast(data.message, 'error', 10000);
            } else if (data.status === 400) {
              Toast('Onbekende fout.', 'error', 10000);
            }

            overlay.close();
          })
          .catch((error) => {
            console.error('Error:', error);
            Toast('Onbekende fout.', 'error', 10000);
            overlay.close();
          });
      });
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
